import { render, staticRenderFns } from "./CommunityButtons.vue?vue&type=template&id=00948b6f"
import script from "./CommunityButtons.vue?vue&type=script&lang=js"
export * from "./CommunityButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports